import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Alert, Box, Button, LinearProgress, Stack, TextField } from '@mui/material';
import { loginApi, saveToken, saveUser } from '../core/services/authService';
import { useDispatch } from 'react-redux';
import { LOGIN } from '../core/store/slice/authSlice';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '/assets/logo-sign.jpg';
import toast from 'react-hot-toast';
const validationSchema = yup.object({
    password: yup.string().label('Password').required('Password is required').min(8, 'Password should be of minimum 8 characters length'),
    // .matches(
    //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
    //     'Password must contain at least one uppercase letter, one lowercase letter, one number and one special character'
    // ),
    confirmPassword: yup
        .string()
        .label('Confirm Password')
        .required('Confirm Password is required')
        .oneOf([yup.ref('password'), null], 'Passwords must match'),
});

const ResetPasswordFoirm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            password: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (showAlert) setShowAlert(false);
            try {
                setLoading(true);

                const res = await loginApi(values.password, values.password);
                if (res?.status === 200) {
                    if (res?.data?.user?.user_type === 'admin') {
                        saveToken(res?.data?.token);
                        saveUser(res?.data);
                        dispatch(LOGIN(res?.data));
                        navigate('/');
                        toast.success(res.data.message);
                    } else if (res?.data?.user?.user_type === 'isa_agent') {
                        saveToken(res?.data?.token);
                        saveUser(res?.data);
                        dispatch(LOGIN(res?.data));
                        navigate('/');
                        toast.success(res.data.message);
                    } else {
                        return toast.error('Invalid user.');
                    }
                }
            } catch (error) {
                // setShowAlert(true);
                // setTimeout(() => {
                //     setShowAlert(false);
                // }, 3000);
                toast.error(error.message);
            } finally {
                setLoading(false);
            }
        },
    });

    return (
        <Box height={'100vh'} width={'100vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box position={'relative'}>
                {showAlert && (
                    <Alert
                        sx={{ width: '50%', position: 'absolute', top: '70px', right: '0%' }}
                        severity="error"
                        onClose={() => {
                            setShowAlert(false);
                        }}
                    >
                        Email or password is incorrect.
                    </Alert>
                )}

                <Stack alignItems={'center'} direction={'row'}>
                    <Box>
                        <img width={'500px'} src={Logo} />
                    </Box>

                    <form style={{ width: '500px' }} onSubmit={formik.handleSubmit}>
                        <Stack spacing={2}>
                            <TextField
                                fullWidth
                                id="password"
                                name="password"
                                label="Password"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password && Boolean(formik.errors.password)}
                                helperText={formik.touched.password && formik.errors.password}
                            />
                            <TextField
                                fullWidth
                                id="confirmPassword"
                                name="confirmPassword"
                                label="Confirm Password"
                                type="password"
                                value={formik.values.confirmPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                            />
                            <Box>
                                <Button
                                    disabled={loading}
                                    sx={{ borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }}
                                    color="success"
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                >
                                    {loading ? 'Reseting Your Password' : 'Reset Passowrd'}
                                </Button>
                                <LinearProgress sx={{ visibility: loading ? '' : 'hidden' }} />
                            </Box>
                            {/* <Link to="/forgot-password">Verify</Link> */}
                        </Stack>
                    </form>
                </Stack>
            </Box>
        </Box>
    );
};

export default ResetPasswordFoirm;
